export enum EThemeKey {
  DEFAULT = 'DEFAULT',
  PRIMARY = 'PRIMARY',
  DARK = 'DARK'
}

export const THEMES_KEYS = Object.values(EThemeKey);
